export const getReviewsAverage = (
  totalReviews: number,
  reviewsByStar: number[],
) => {
  if (!totalReviews || !reviewsByStar?.length) {
    return 0;
  }
  const amount = reviewsByStar.reduce((acc, count, index) => {
    return acc + (count / totalReviews) * (index + 1);
  }, 0);
  return amount;
};
